import React from 'react';
import { connect } from 'react-redux';
import { Field } from 'react-final-form';
import { OnChange } from 'react-final-form-listeners';
import { Form, Col, Card, Alert } from 'react-bootstrap';

//Actions
import { pesquisa } from '../../../actions/login/login';

import { campotexto, camposelect } from '../campos/campos';
import { getTraducaoTrocaPor as trad, getCampoTraducao as tradCampo } from '../../../utils/getTraducoes';
import { getDadosToOptions } from '../utils/toolsforms';
import { getUserLoginCred } from '../../../utils/eventosessioncred';

class DadosPessoais extends React.Component {

    state = {
        logado: false,
        nomecracha: '',
        sobrenomecracha: '',
        cpf_pesquisa_existe: false
    }

    cadastro = {}

    componentDidMount() {
        this.cadastro = getUserLoginCred();
        this.setState({
            logado: (this.cadastro && this.cadastro.fisica && this.cadastro.fisica.idfisica ? true : false)
        });
    }

    handleTratamentos = (tratamentos) => {
        let result = getDadosToOptions(tratamentos, tradCampo(this.props.lingua), trad, this.props.trads, tradCampo(this.props.lingua), 'SELECIONE');
        return result;
    }

    handleNome = (value) => {
        this.setState({
            nomecracha: value
        });

        const sobrenome = this.props.form.getFieldState('sobrenome');

        console.log(sobrenome.value);

        this.props.form.batch(() => {
            this.props.form.change('cracha', sobrenome.value!==undefined&&sobrenome.value!==''?value+' '+sobrenome.value:value);
        });
    }

    handleSobrenome = (value) => {
        this.setState({
            sobrenomecracha: value
        });

        this.props.form.batch(() => {
            this.props.form.change('cracha', this.state.nomecracha + ' ' + value);
        });
    }

    handleValidacao = (...validators) => value => {        
        validators.reduce(async (error, validator) => {
            return error || await validator(value)
        }, undefined);
    }

    handlePesquisaCpf = async (cpf) => {
        const response = await this.props.pesquisa({
            idpromotora: this.props.dadosevento.idpromotora,
            idevento: this.props.dadosevento.idevento,
            cpf: cpf
        });
        return response;
    }

    handleValidaCpf = async (cpf) => {

        let email = this.cadastro && this.cadastro.fisica && this.cadastro.fisica.idfisica?{value:this.cadastro.fisica.email}:this.props.form.getFieldState('email');        
        
        if (cpf && cpf !== '' && cpf.length === 11 && email) {

            const response = await this.handlePesquisaCpf(cpf);
            
            if(response.result === true){
                delete response.result;
                const result = Object.keys(response).filter(itens => {                    
                    return response[itens].email === email.value
                });                
                const email_existe = response[0].email.split("@");
                  
                if(result.length === 0){
                    return (
                        <Alert variant="warning">
                            <small>
                                <strong>
                        Ops! Encontrei cadastro com este CPF<br/><br/>
                        Caso esteja tentando acessar seus dados, retorne para a página de login e acesse seus dados utilizando e-mail ****@{email_existe[1]}<br/><br/>
                        Caso seja um novo cadastro informe um CPF diferente
                        </strong>
                        </small>
                        </Alert>
                    );
                }else{
                    return undefined;
                }
            }else{
                return undefined;
            }
        }else{
            return undefined
        }
    }

    render() {
        const trads = this.props.trads;
        const lingua = this.props.lingua;

        return (
            <Card className='mb-3'>
                <Card.Header><Card.Title>{trad(trads, 'PESSOAIS', lingua)}</Card.Title></Card.Header>
                <Card.Body>
                    <Form.Row>
                        <Form.Group as={Col} md="4" controlId="cpf" style={this.props.styles['cpf'] ? this.props.styles['cpf'] : {}}>
                            <Field type='tel'
                                styles={this.props.styles}
                                mask="99999999999"
                                maskPlaceholder={null}
                                placeholder={trad(trads, 'TITLECPF', lingua)}
                                label={trad(trads, 'TITLECPF', lingua)}
                                name='cpf' component={campotexto}
                            />
                            <OnChange name="cpf">
                                {((value) => {
                                    this.handleValidaCpf(value)
                                })}
                            </OnChange>
                        </Form.Group>                    
                        <Form.Group as={Col} md="4" controlId="nascimento" style={this.props.styles['nascimento'] ? this.props.styles['nascimento'] : {}}>
                            <Field type='tel'
                                styles={this.props.styles}
                                mask="99/99/9999"
                                placeholder={trad(trads, 'DATA_NASC', lingua)}
                                label={trad(trads, 'DATA_NASC', lingua)} name='nascimento' component={campotexto} />
                        </Form.Group>
                        <Form.Group as={Col} md="4" controlId="sexo" style={this.props.styles['sexo'] ? this.props.styles['sexo'] : {}}>
                            <Field
                                styles={this.props.styles}
                                placeholder={trad(trads, 'TITLESEXO', lingua)}
                                options={[
                                    { "texto": trad(trads, 'SELECIONE', lingua), "value": "" },
                                    { "texto": trad(trads, 'TITLEM', lingua), "value": "M" },
                                    { "texto": trad(trads, 'TITLEF', lingua), "value": "F" }
                                ]}
                                label={trad(trads, 'TITLESEXO', lingua)} name='sexo' component={camposelect} />
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} md="2" controlId="idtratamento" style={this.props.styles['idtratamento'] ? this.props.styles['idtratamento'] : {}}>
                            <Field
                                styles={this.props.styles}
                                placeholder={trad(trads, 'TRATAMENTO', lingua)}
                                options={this.handleTratamentos(this.props.tratamentos)}
                                label={trad(trads, 'TRATAMENTO', lingua)} name='idtratamento' component={camposelect} />
                        </Form.Group>
                        <Form.Group as={Col} md="3" controlId="nome" style={this.props.styles['nome'] ? this.props.styles['nome'] : {}}>
                            <Field type='text'
                                styles={this.props.styles}
                                placeholder={trad(trads, 'TITLENOME', lingua)}
                                label={trad(trads, 'TITLENOME', lingua)}
                                name='nome'
                                component={campotexto}
                                readOnly={this.state.logado && true} />
                            <OnChange name="nome">
                                {this.handleNome}
                            </OnChange>
                        </Form.Group>
                        <Form.Group as={Col} md="3" controlId="sobrenome" style={this.props.styles['sobrenome'] ? this.props.styles['sobrenome'] : {}}>
                            <Field type='text'
                                styles={this.props.styles}
                                placeholder={trad(trads, 'TITLESOBRENOME', lingua)}
                                label={trad(trads, 'TITLESOBRENOME', lingua)}
                                name='sobrenome'
                                component={campotexto}
                                readOnly={this.state.logado && true} />
                            <OnChange name="sobrenome">
                                {this.handleSobrenome}
                            </OnChange>
                        </Form.Group>
                        <Form.Group as={Col} md="4" controlId="cracha" style={this.props.styles['cracha'] ? this.props.styles['cracha'] : {}}>
                            <Field type='text'
                                styles={this.props.styles}
                                placeholder={trad(trads, 'TITLECRACHA', lingua)}
                                label={trad(trads, 'TITLECRACHA', lingua)} name='cracha' component={campotexto}
                                readOnly={true}
                            />
                        </Form.Group>
                    </Form.Row>
                </Card.Body>
            </Card>
        );
    }
}

export default connect(null,{pesquisa})(DadosPessoais);